import React from "react";

const dummySuggestions = [
  { id: 1, user: "Bob", message: "Add dark mode." },
  { id: 2, user: "Dana", message: "More export options." },
];

const SuggestionsPage = () => (
  <div className="p-8 text-ez-text-primary dark:text-ez-text-primary">
    <h2 className="text-2xl font-bold mb-6">Suggestions</h2>
    <div className="overflow-hidden border border-ez-border dark:border-ez-border bg-white dark:bg-ez-surface shadow-sm">
      <table className="min-w-full">
        <thead className="bg-ez-elevated dark:bg-ez-elevated text-ez-text-secondary dark:text-ez-text-primary">
          <tr>
            <th className="py-3 px-4 border-b border-ez-border dark:border-ez-border">ID</th>
            <th className="py-3 px-4 border-b border-ez-border dark:border-ez-border">User</th>
            <th className="py-3 px-4 border-b border-ez-border dark:border-ez-border">Message</th>
          </tr>
        </thead>
        <tbody className="text-ez-text-secondary dark:text-ez-text-primary">
          {dummySuggestions.map(item => (
            <tr key={item.id} className="border-b border-ez-border dark:border-ez-border hover:bg-ez-elevated dark:hover:bg-ez-elevated">
              <td className="py-3 px-4 text-center">{item.id}</td>
              <td className="py-3 px-4">{item.user}</td>
              <td className="py-3 px-4">{item.message}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);

export default SuggestionsPage;



